import { AutomationActionNodeSubType, IConditionOptionChoice } from '@services/automations';
import { TemplateType } from '@services/communities';

export interface IActionOption {
  type: AutomationActionNodeSubType;
  displayName: string;
  updateTypes?: string[];
}

export interface ISendEmailActionOption extends IActionOption {
  messageTemplates: IMessageTemplateData[];
  emailResources: IEmailResourceData[];
  fieldsMap?: Record<string, unknown>;
}

export enum UpdateMemberDataActionTypes {
  ADD_TAG = 'ADD_TAG',
  REMOVE_TAG = 'REMOVE_TAG',
  ADD_TO_GROUP = 'ADD_TO_GROUP',
  REMOVE_FROM_GROUP = 'REMOVE_FROM_GROUP',
  UPDATE_MEMBER_INFORMATION = 'UPDATE_MEMBER_INFORMATION',
}

export type UpdateMemberDataActionType = typeof UpdateMemberDataActionTypes[keyof typeof UpdateMemberDataActionTypes];

export interface IUpdateMemberDataActionOption extends IActionOption {
  updateTypes: UpdateMemberDataActionTypes[];
  fieldsMap: unknown;
  tags?: IConditionOptionChoice[];
  groups?: IConditionOptionChoice[];
}

export interface IMessageTemplateData {
  id: number;
  displayName: string;
  messageTemplateType?: TemplateType;
  programId?: number;
  emailSubject?: string;
}

export interface IEmailResourceData {
  displayName: string;
  fromPreviousSender?: boolean;
  id?: number;
  userId?: string;
}
